import React from "react";
// import * as FaIcons from 'react-icons/fa'
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

export const SidebarData = [
	{
		title: "Home",
		path: "#home",
		icon: <AiIcons.AiFillHome />,
		iconClosed: <RiIcons.RiArrowDownSFill />,
		iconOpened: <RiIcons.RiArrowUpSFill />,
	},
	{
		title: "Calendar",
		path: "#calendar",
		icon: <AiIcons.AiFillCalendar />,
		iconClosed: <RiIcons.RiArrowDownSFill />,
		iconOpened: <RiIcons.RiArrowUpSFill />,
	},
	{
		title: "Standings",
		path: "#standings",
		icon: <IoIcons.IoIosPaper />,
		iconClosed: <RiIcons.RiArrowDownSFill />,
		iconOpened: <RiIcons.RiArrowUpSFill />,
	},
	{
		title: "Past Streams",
		path: "#pastStreams",
		icon: <AiIcons.AiFillVideoCamera />,
	},
	{
		title: "Gallery",
		path: "#gallery",
		icon: <AiIcons.AiFillCamera />,
	},
	{
		title: "Hall of Fame",
		path: "#hallOfFame",
		icon: <AiIcons.AiFillCrown />,
	},
];

export const pageLinks = [
	{ id: 1, href: "#home", text: "home" },
	{ id: 2, href: "#calendar", text: "calendar" },
	{ id: 3, href: "#standings", text: "standings" },
	{ id: 4, href: "#pastStreams", text: "past streams" },
	{ id: 5, href: "#gallery", text: "gallery" },
	{ id: 6, href: "#hallOfFame", text: "hall of fame" },
];

export const socialLinks = [
	{
		id: 1,
		href: "https://www.facebook.com/SpeedForceRacingPS4/",
		icon: "fab fa-facebook",
	},
	{
		id: 2,
		href: "https://twitter.com/SFRps4",
		icon: "fab fa-twitter",
	},
	{
		id: 3,
		href: "https://discord.gg/8hB3MMfGy4",
		icon: "fab fa-discord",
	},
];

export const currentHofConfig = [
	{
		id: 15,
		season: "15",
		src: "/images/hof-s15.png",
	},
	{
		id: 14,
		season: "14",
		src: "/images/hof-s14.png",
	},
];

export const hofConfig = [
	{
		id: 13,
		season: "13",
		src: "/images/hof-s13.png",
	},
	{
		id: 12,
		season: "12",
		src: "/images/hof-s12.png",
	},
	{
		id: 11,
		season: "11",
		src: "/images/hof-s11.png",
	},
	{
		id: 10,
		season: "10",
		src: "/images/hof-s10.png",
	},
	{
		id: 9,
		season: "9",
		src: "/images/hof-s9.png",
	},
	{
		id: 8,
		season: "8",
		src: "/images/hof-s8.png",
	},
	{
		id: 7,
		season: "7",
		src: "/images/hof-s7.png",
	},
	{
		id: 6,
		season: "6",
		src: "/images/hof-s6.png",
	},
	{
		id: 5,
		season: "5",
		src: "/images/hof-s5.png",
	},
	{
		id: 4,
		season: "4",
		src: "/images/hof-s4.png",
	},
	{
		id: 3,
		season: "3",
		src: "/images/hof-s3.png",
	},
	{
		id: 2,
		season: "2",
		src: "/images/hof-s2.png",
	},
	{
		id: 1,
		season: "1",
		src: "/images/hof-s1.png",
	},
];

export const gp1Slider = [
	{
		id: 1,
		imgPath: "/images/oliver-spa-3.png",
		desc: "Division 2 tackling the famous Eau Rouge at Spa in Round 2",
	},
	{
		id: 2,
		imgPath: "/images/oliver-spa-2.png",
		desc: "The Ferrari of 5STR-OliverWRC charging through the field in Round 2 at Spa",
	},
	{
		id: 3,
		imgPath: "/images/oliver-spa-1.png",
		desc: "Some close battles down the straight at Spa in Division 2",
	},
	{
		id: 4,
		imgPath: "/images/oliver-spa-4.png",
		desc: "The Ferrari of 5STR-OliverWRC lining up an overtake on the unsuspecting Haas",
	},
];

export const streamConfig = [
	{
		id: 1,
		src: "https://www.youtube.com/embed/_1AUINI38gM?si=00CRD1eORMjxJ2ty",
		title: "Div 1 - Rnd 2 - Belgium",
	},
	{
		id: 2,
		src: "https://www.youtube.com/embed/Vu9lZ810cbY?si=9sBRXH3V3G-E1K7m",
		title: "Div 2 - Rnd 1 - Bahrain",
	},
	// {
	// 	id: 3,
	// 	src: "https://www.youtube.com/embed/lQAqiLNbxC8",
	// 	title: "Div 3 - Rnd 2 - Austria",
	// },
	// {
	// 	id: 4,
	// 	src: "https://www.youtube.com/embed/QueECO4yv7c",
	// 	title: "Div 4 - Rnd 17 - Silverstone",
	// },
];

export const mergedStandingsConfig = [
	//Division 1
	{
		id: 1,
		position: "1",
		league: 1,
		name: "TTVKaname",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "5",
		fastest: "1",
		points: "163",
	},
	{
		id: 2,
		position: "2",
		league: 1,
		name: "Fireblaze95_",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "162",
	},
	{
		id: 3,
		position: "3",
		league: 1,
		name: "DF_Laser",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "",
		podiums: "2",
		fastest: "",
		points: "157",
	},
	{
		id: 4,
		position: "4",
		league: 1,
		name: "CT_Noldus",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "140",
	},
	{
		id: 5,
		position: "5",
		league: 1,
		name: "SHZ_JensenR",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "3",
		podiums: "4",
		fastest: "1",
		points: "138",
	},
	{
		id: 6,
		position: "6",
		league: 1,
		name: "rising_star1115",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "",
		podiums: "2",
		fastest: "",
		points: "131",
	},
	{
		id: 7,
		position: "7",
		league: 1,
		name: "OWR_Harry_Kane05",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "1",
		podiums: "2",
		fastest: "",
		points: "114",
	},
	{
		id: 8,
		position: "8",
		league: 1,
		name: "Rac1ngn0m1a",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "92",
	},
	{
		id: 9,
		position: "9",
		league: 1,
		name: "OWR_Draugen",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "91",
	},
	{
		id: 10,
		position: "10",
		league: 1,
		name: "TNR_Langfjell",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "70",
	},
	{
		id: 11,
		position: "11",
		league: 1,
		name: "OWR_BareRemi",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "59",
	},
	{
		id: 12,
		position: "12",
		league: 1,
		name: "pocketvalleyguy",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "41",
	},
	{
		id: 13,
		position: "13",
		league: 1,
		name: "Turbo",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "33",
	},
	{
		id: 14,
		position: "14",
		league: 1,
		name: "Hussein",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "28",
	},
	{
		id: 15,
		position: "15",
		league: 1,
		name: "MSA_Samad",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "22",
	},
	{
		id: 16,
		position: "16",
		league: 1,
		name: "Robin_R-_-",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "17",
	},
	{
		id: 17,
		position: "17",
		league: 1,
		name: "F1_WilgnerM6",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "9",
	},
	{
		id: 18,
		position: "18",
		league: 1,
		name: "Klopit_96",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "2",
		fastest: "",
		points: "0",
	},
	{
		id: 19,
		position: "19",
		league: 1,
		name: "X_Mika66",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "0",
	},
	{
		id: 20,
		position: "20",
		league: 1,
		name: "denniskers",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "0",
	},

	//Division 2

	{
		id: 21,
		position: "1",
		league: 2,
		name: "Bur-Meister",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "4",
		podiums: "9",
		fastest: "1",
		points: "216",
	},
	{
		id: 22,
		position: "2",
		league: 2,
		name: "Yousef",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "3",
		podiums: "6",
		fastest: "2",
		points: "157",
	},
	{
		id: 23,
		position: "3",
		league: 2,
		name: "Yarham",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "1",
		podiums: "4",
		fastest: "1",
		points: "142",
	},
	{
		id: 24,
		position: "4",
		league: 2,
		name: "VeloceAyubJr",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "140",
	},
	{
		id: 25,
		position: "5",
		league: 2,
		name: "Aydams1",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "130",
	},
	{
		id: 26,
		position: "6",
		league: 2,
		name: "neymarmig11",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		podiums: "3",
		fastest: "",
		points: "127",
	},
	{
		id: 27,
		position: "7",
		league: 2,
		name: "Klusser40",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "101",
	},
	{
		id: 28,
		position: "8",
		league: 2,
		name: "OWR_Atlascopo",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "93",
	},
	{
		id: 29,
		position: "9",
		league: 2,
		name: "SFR_OliverF1",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "93",
	},
	{
		id: 31,
		position: "11",
		league: 2,
		name: "OWR_LordDannyBoy",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "84",
	},
	{
		id: 32,
		position: "12",
		league: 2,
		name: "LORDALAM786",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "75",
	},
	{
		id: 33,
		position: "13",
		league: 2,
		name: "Caspinjo_22",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "64",
	},
	{
		id: 34,
		position: "14",
		league: 2,
		name: "OWR_Emils1991",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "57",
	},
	{
		id: 35,
		position: "15",
		league: 2,
		name: "OWR_Xenon",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "52",
	},
	{
		id: 36,
		position: "16",
		league: 2,
		name: "PresidentElite",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "37",
	},
	{
		id: 37,
		position: "17",
		league: 2,
		name: "mdj2002mdj",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "16",
	},
	{
		id: 38,
		position: "18",
		league: 2,
		name: "FGL_Rulda",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "11",
	},
	{
		id: 39,
		position: "19",
		league: 2,
		name: "SuperStriker9",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "0",
	},

	// Division 3

	{
		id: 41,
		position: "1",
		league: 3,
		name: "OWR_Prberli",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "2",
		podiums: "4",
		fastest: "",
		points: "180",
	},
	{
		id: 42,
		position: "2",
		league: 3,
		name: "SFR_Energydan",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		podiums: "6",
		fastest: "1",
		points: "178",
	},
	{
		id: 43,
		position: "3",
		league: 3,
		name: "SFR_Keefs",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "",
		podiums: "2",
		fastest: "1",
		points: "152",
	},
	{
		id: 44,
		position: "4",
		league: 3,
		name: "MrWiggles",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "1",
		podiums: "4",
		fastest: "",
		points: "147",
	},
	{
		id: 45,
		position: "5",
		league: 3,
		name: "OWR_Halvor",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "141",
	},
	{
		id: 46,
		position: "6",
		league: 3,
		name: "Skanny",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "135",
	},
	{
		id: 47,
		position: "7",
		league: 3,
		name: "OWR_Staink",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "1",
		podiums: "3",
		fastest: "1",
		points: "126",
	},
	{
		id: 48,
		position: "8",
		league: 3,
		name: "Cassidy1690",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "119",
	},
	{
		id: 49,
		position: "9",
		league: 3,
		name: "xelliecx",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "2",
		fastest: "",
		points: "114",
	},
	{
		id: 50,
		position: "13",
		league: 3,
		name: "AbdallaAyman20",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "90",
	},
	{
		id: 51,
		position: "11",
		league: 3,
		name: "OWR_Ronny",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "87",
	},
	{
		id: 52,
		position: "12",
		league: 3,
		name: "OWR_Mithrandir",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "1",
		fastest: "",
		points: "84",
	},
	{
		id: 53,
		position: "13",
		league: 3,
		name: "GEVI_Orieuglas",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "78",
	},
	{
		id: 54,
		position: "14",
		league: 3,
		name: "ZZG-SpeedyB",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "1",
		podiums: "1",
		fastest: "",
		points: "48.5",
	},
	{
		id: 55,
		position: "15",
		league: 3,
		name: "Utkarsh_xiri",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "27",
	},
	{
		id: 56,
		position: "16",
		league: 3,
		name: "DXT_Matty_22",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "21",
	},
	{
		id: 57,
		position: "17",
		league: 3,
		name: "SFR_Mhartin",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "19",
	},
	{
		id: 58,
		position: "18",
		league: 3,
		name: "Justspider20",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "11",
	},

	// Division 4

	{
		id: 61,
		position: "1",
		league: 4,
		name: "BillyG1977",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "3",
		podiums: "7",
		fastest: "2",
		points: "207",
	},
	{
		id: 62,
		position: "2",
		league: 4,
		name: "SFR_thevicar",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "4",
		podiums: "8",
		fastest: "1",
		points: "203",
	},
	{
		id: 63,
		position: "3",
		league: 4,
		name: "SFR_Doran",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "1",
		podiums: "4",
		fastest: "",
		points: "173",
	},
	{
		id: 64,
		position: "4",
		league: 4,
		name: "Dom9180",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		podiums: "3",
		fastest: "2",
		points: "163",
	},
	{
		id: 65,
		position: "5",
		league: 4,
		name: "Jonmowbs",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		podiums: "3",
		fastest: "1",
		points: "150",
	},
	{
		id: 66,
		position: "6",
		league: 4,
		name: "OWR_AlexHaug",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "150",
	},
	{
		id: 67,
		position: "7",
		league: 4,
		name: "DanKDLaa",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		podiums: "3",
		fastest: "",
		points: "132",
	},
	{
		id: 68,
		position: "8",
		league: 4,
		name: "OWR_Silverfox",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "122",
	},
	{
		id: 69,
		position: "9",
		league: 4,
		name: "redoubts",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "106",
	},
	{
		id: 70,
		position: "10",
		league: 4,
		name: "DylanVince",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "91",
	},
	{
		id: 71,
		position: "11",
		league: 4,
		name: "brassmonkies",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "91",
	},
	{
		id: 72,
		position: "12",
		league: 4,
		name: "Knightcreed11",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "84",
	},
	{
		id: 73,
		position: "13",
		league: 4,
		name: "OWR_Preb1",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "79",
	},
	{
		id: 74,
		position: "14",
		league: 4,
		name: "Btlwakeyjoe",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "1",
		points: "49",
	},
	{
		id: 75,
		position: "15",
		league: 4,
		name: "SFR_MadG",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "48",
	},
	{
		id: 76,
		position: "16",
		league: 4,
		name: "Smothoperater17",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "39",
	},
	{
		id: 77,
		position: "17",
		league: 4,
		name: "SFR_Simmo007",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "22",
	},
	{
		id: 78,
		position: "18",
		league: 4,
		name: "JamezZkiller",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		podiums: "",
		fastest: "",
		points: "14",
	},
];

export const mergedConstructorsConfig = [
	{
		id: 1,
		position: "1",
		league: 1,
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "3",
		points: "280",
	},
	{
		id: 2,
		position: "2",
		league: 1,
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		points: "268",
	},
	{
		id: 3,
		position: "3",
		league: 1,
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "3",
		points: "264",
	},
	{
		id: 4,
		position: "4",
		league: 1,
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "1",
		points: "230",
	},
	{
		id: 5,
		position: "5",
		league: 1,
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "1",
		points: "223",
	},
	{
		id: 6,
		position: "6",
		league: 1,
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		points: "220",
	},
	{
		id: 7,
		position: "7",
		league: 1,
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		points: "166",
	},
	{
		id: 8,
		position: "8",
		league: 1,
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "2",
		points: "155",
	},
	{
		id: 9,
		position: "9",
		league: 1,
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		points: "147",
	},
	{
		id: 10,
		position: "10",
		league: 1,
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		points: "147",
	},

	// Division 2
	{
		id: 11,
		position: "1",
		league: 2,
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "4",
		points: "324",
	},
	{
		id: 12,
		position: "2",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		league: 2,
		wins: "3",
		points: "293",
	},
	{
		id: 13,
		position: "3",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		league: 2,
		wins: "1",
		points: "243",
	},
	{
		id: 14,
		position: "4",
		league: 2,
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "1",
		points: "243",
	},
	{
		id: 15,
		position: "5",
		league: 2,
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		points: "220",
	},
	{
		id: 16,
		position: "6",
		league: 2,
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		points: "212",
	},
	{
		id: 17,
		position: "7",
		league: 2,
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "",
		points: "171",
	},
	{
		id: 18,
		position: "8",
		league: 2,
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		points: "163",
	},
	{
		id: 19,
		position: "9",
		league: 2,
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "",
		points: "145",
	},
	{
		id: 20,
		position: "10",
		league: 2,
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		points: "117",
	},

	// Division 3

	{
		id: 31,
		position: "1",
		league: 3,
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		points: "330",
	},
	{
		id: 32,
		position: "2",
		league: 3,
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "1",
		points: "267",
	},
	{
		id: 33,
		position: "3",
		league: 3,
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "2",
		points: "264",
	},
	{
		id: 34,
		position: "4",
		league: 3,
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		points: "256",
	},
	{
		id: 35,
		position: "5,",
		league: 3,
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "1",
		points: "227",
	},
	{
		id: 36,
		position: "6",
		league: 3,
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "2",
		points: "169",
	},
	{
		id: 37,
		position: "7",
		league: 3,
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		points: "162",
	},
	{
		id: 38,
		position: "8",
		league: 3,
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "2",
		points: "153",
	},
	{
		id: 39,
		position: "9",
		league: 3,
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "",
		points: "111",
	},
	{
		id: 40,
		position: "10",
		league: 3,
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		points: "111",
	},

	// Division 4

	{
		id: 41,
		position: "1",
		league: 4,
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		wins: "4",
		points: "380",
	},
	{
		id: 42,
		position: "2",
		league: 4,
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		wins: "4",
		points: "353",
	},
	{
		id: 43,
		position: "3",
		league: 4,
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		wins: "",
		points: "282",
	},
	{
		id: 44,
		position: "4",
		league: 4,
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		wins: "",
		points: "201",
	},
	{
		id: 45,
		position: "5",
		league: 4,
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		wins: "",
		points: "197",
	},
	{
		id: 46,
		position: "6",
		league: 4,
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		wins: "1",
		points: "185",
	},
	{
		id: 47,
		position: "7",
		league: 4,
		team: "Williams",
		teamBadge: "/images/team-will.png",
		wins: "",
		points: "123",
	},
	{
		id: 48,
		position: "8",
		league: 4,
		team: "RB",
		teamBadge: "/images/team-visa.png",
		wins: "",
		points: "118",
	},
	{
		id: 49,
		position: "9",
		league: 4,
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		wins: "",
		points: "97",
	},
	{
		id: 50,
		position: "10",
		league: 4,
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		wins: "1",
		points: "47",
	},
];

export const constructorsAllConfig = [
	{
		id: 1,
		position: "1",
		team: "Red Bull",
		teamBadge: "/images/team-rb.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 2,
		position: "2",
		team: "Alpine",
		teamBadge: "/images/team-alp.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 3,
		position: "3",
		team: "Williams",
		teamBadge: "/images/team-will.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 4,
		position: "4",
		team: "McLaren",
		teamBadge: "/images/team-mcl.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 5,
		position: "5",
		team: "Haas",
		teamBadge: "/images/team-haas.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 6,
		position: "6",
		team: "Aston Martin",
		teamBadge: "/images/team-am.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 7,
		position: "7",
		team: "Kick Sauber",
		teamBadge: "/images/team-kick.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 8,
		position: "8",
		team: "Mercedes",
		teamBadge: "/images/team-merc.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 9,
		position: "9",
		team: "RB",
		teamBadge: "/images/team-visa.png",
		div1: "",
		div2: "",
		div3: "",
	},
	{
		id: 10,
		position: "10",
		team: "Ferrari",
		teamBadge: "/images/team-fer.png",
		div1: "",
		div2: "",
		div3: "",
	},
];
